import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-records-overlay',
  templateUrl: './no-records-overlay.component.html',
  styleUrls: ['./no-records-overlay.component.css']
})
export class NoRecordsOverlayComponent implements OnInit {
  @Input() showOverlay: boolean = false;
  @Input() message: string = 'No hay registros';
  @Input() subMessage: string = 'No se encontraron datos para mostrar';
  @Input() icon: string = 'fas fa-inbox';
  @Input() iconColor: string = '#dee2e6';
  @Input() height: string = '400px';
  @Input() overlayClass: string = 'no-records-overlay';
  @Input() containerClass: string = 'text-center no-records-container';

  heightCategory: string = 'medium';

  ngOnInit() {
    this.determineHeightCategory();
  }

  ngOnChanges() {
    this.determineHeightCategory();
  }

  private determineHeightCategory() {
    const heightValue = parseInt(this.height.replace('px', ''));

    if (heightValue <= 300) {
      this.heightCategory = 'small';
    } else if (heightValue <= 500) {
      this.heightCategory = 'medium';
    } else {
      this.heightCategory = 'large';
    }
  }

  getOverlayClasses(): string {
    return `${this.overlayClass} position-absolute d-flex align-items-center justify-content-center`;
  }
}
